var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "提示",
        "custom-class": "pluginVideo",
        visible: _vm.dialogVisible,
        width: "680px",
        "append-to-body": "",
        "before-close": _vm.beforeClose,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c("div", [
        _vm.isNeedTips
          ? _c("p", { staticClass: "mb20 font18" }, [
              _vm._v("检测到您未安装插件，店铺诊断须安装插件才能使用"),
            ])
          : _vm._e(),
        _c(
          "video",
          {
            ref: "video",
            attrs: {
              width: "100%",
              height: "400px",
              controls: "",
              id: "pluginVideo",
              muted: "",
            },
            domProps: { muted: true },
          },
          [
            _c("source", {
              attrs: {
                src: "https://cloud.video.taobao.com/play/u/2216950060407/p/2/e/6/t/1/458563757384.mp4",
                type: "video/mp4",
              },
            }),
          ]
        ),
      ]),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.dialogVisible = false
                },
              },
            },
            [_vm._v("取消")]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.confirm } },
            [_vm._v("下载插件")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }